import React from "react";

import DownloadIcon from "@uui/Download01";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import type { Topic } from "@app/analytics/types";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Menu from "@rui/Menu";
import MenuItem from "@rui/MenuItem";

import DownloadLink from "./DownloadLink";

const DownloadMenu = ({ topic }: { topic: Topic }) => {
  const { anchorElement, open, onClose, onClick } = useAnchorElement();

  return (
    <>
      <HeaderButton startIcon={<DownloadIcon />} onClick={onClick}>
        Download
      </HeaderButton>

      <Menu open={open} onClose={onClose} anchorEl={anchorElement}>
        <MenuItem sx={{ padding: 0 }}>
          <DownloadLink topic={topic} onClose={onClose} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default DownloadMenu;
